module.exports = __webpack_public_path__ + "static/media/nightclub.10e93420.jpg";